import { OMR_FeeStatementPaymentModel } from './omr_FeeStatementPaymentModel';
export class OMR_FeeStatementServiceModel {
    public fee_statement_service_id: string = '';
    public fee_statement_id: string = '';
    public dx_number_txt: string = '';
    public dos_dt: string = '';
    public code_txt: string = '';
    public service_name_txt: string = '';
    public description_txt: string = '';
    public unit_amt: number = 0.00;
    public unit_cnt: number = 1.00;
    public tax_rate_amt: number = 0.00;
    public tax_amt: number = 0.00;
    public discount_per_amt: number = 0.00;
    public discount_amt: number = 0.00;
    public fee_amt:  number = 0.00;
    public pat_total: number = 0.00;
    public ins_total: number = 0.00;
    public status_txt: string = '';
    public created_dt: string = '';
    public created_by: string = '';
    public updated_dt: string = '';
    public updated_by: string = '';
    public order_val: number = 0.00;
    public item_id: string = '';
    public isShow : boolean = false;
    public omR_FeeStatementPayment: OMR_FeeStatementPaymentModel[] = [];
}
